/* Presentation only: the existing application owns display, consent and submission. */
(() => {
  const normalise = text => (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const decorate = () => {
    document.querySelectorAll('h1, h2, h3, h4, p, strong, span').forEach(title => {
      if (!/^-10\s*% sur votre première commande$/.test(normalise(title.textContent))) return;
      if (title.closest('.bfc-welcome-offer__title')) return;
      let panel = title.parentElement;
      while (panel && panel !== document.body) {
        const email = panel.querySelector('input[type="email"]');
        const submit = Array.from(panel.querySelectorAll('button, input[type="submit"]'))
          .find(button => normalise(button.textContent || button.value) === 'obtenir mon code');
        if (email && submit) {
          /* Never decorate a page-level wrapper if the application markup changes. */
          if (panel.matches('main, header, footer') || panel.querySelector('main, header, footer')) return;
          panel.classList.add('bfc-welcome-offer');
          title.classList.add('bfc-welcome-offer__title');
          email.classList.add('bfc-welcome-offer__email');
          submit.classList.add('bfc-welcome-offer__submit');
          const dialog = panel.closest('[role="dialog"]') || panel;
          dialog.querySelectorAll('button').forEach(button => {
            const label = normalise(button.getAttribute('aria-label') || button.getAttribute('title') || button.textContent);
            if (/^(close|fermer|dismiss|×)$|close (dialog|form|modal)/.test(label)) button.classList.add('bfc-welcome-offer__close');
          });
          return;
        }
        panel = panel.parentElement;
      }
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; decorate(); });
  });
  decorate();
  observer.observe(document.body, {childList: true, subtree: true});
})();
